import { render, staticRenderFns } from "./HousingIncomeForm.vue?vue&type=template&id=1d99073c"
import script from "./HousingIncomeForm.vue?vue&type=script&lang=js"
export * from "./HousingIncomeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports